import React, { useEffect, useRef } from "react";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import { useDispatch, useSelector } from "react-redux";
import { removeToast } from "../redux/toast";

const RBToaster = () => {
  const items = useSelector((s) => s.toast.items);
  const dispatch = useDispatch();
  const timersRef = useRef({});

  useEffect(() => {
    items.forEach((t) => {
      if (!timersRef.current[t.id]) {
        timersRef.current[t.id] = setTimeout(() => {
          dispatch(removeToast(t.id));
          clearTimeout(timersRef.current[t.id]);
          delete timersRef.current[t.id];
        }, t.duration || 2800);
      }
    });
    return () => {
      Object.values(timersRef.current).forEach((id) => clearTimeout(id));
      timersRef.current = {};
    };
  }, [items, dispatch]);
  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1200 }}>
      {items.map((t) => {
        const typeClass = t.type === "success" ? "pv-toast-card--success" : t.type === "error" ? "pv-toast-card--error" : "pv-toast-card--info";
        return (
          <Toast key={t.id} show onClose={() => dispatch(removeToast(t.id))} animation className={`pv-toast-card ${typeClass}`}>
            <Toast.Body>
              <div className="pv-toast-row">
                <div className="pv-toast-icon" aria-hidden />
                <div className="pv-toast-texts">
                  {t.title && <div className="pv-toast-title">{t.title}</div>}
                  <div className="pv-toast-message">{t.message}</div>
                </div>
              </div>
            </Toast.Body>
          </Toast>
        );
      })}
    </ToastContainer>
  );
};

export default RBToaster;


